
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/dir",
      function () {
        return require("private-next-pages/cases/dir/index.tsx");
      }
    ]);
  